import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import phonakimg from "../../../img/r1.png";
import "../Products/Products.css";
import ReactPlayer from "react-player";
import saveimg from "../../../img/r2.png";
import save2img from "../../../img/r3.png";
import save3img from "../../../img/save3.png";
import save4img from "../../../img/save22.jpg";
import save5img from "../../../img/Phonak-Naida-Paradise.jpg";
import save6img from "../../../img/silde15.jpg";
import sildeimg1 from "../../../img/r4.png";
import sildeimg2 from "../../../img/r5.png";
import sildeimg3 from "../../../img/r6.png";
import sildeimg4 from "../../../img/r7.png";
import sildeimg5 from "../../../img/r8.png";
import sildeimg6 from "../../../img/r9.png";
import sildeimg7 from "../../../img/silde28.png";
import sildeimg9 from "../../../img/silde16.jpg";
import sildeimg10 from "../../../img/r12.png";
import sildeimg13 from "../../../img/save21.jpg";
import sildeimg15 from "../../../img/r11.png";
import sildeimg11 from "../../../img/r10.png";
import sildeimg12 from "../../../img/silde17.jpg";
import tast1 from "../../../img/silde22.jpg";
import tast2 from "../../../img/test2.jpg";
import tast3 from "../../../img/test3.jpg";
import tast4 from "../../../img/test4.jpg";
import mini1 from "../../../img/r13.png";
import mini2 from "../../../img/r14.png";
import mini3 from "../../../img/r15.png";
import mini4 from "../../../img/r16.png";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function ResoundHearingAid() {
  var Products = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480, // Adjust breakpoint as needed
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
       <Helmet>
      <title>ReSound Hearing Aid</title>
        <meta name="description" content="Ready to upgrade your hearing? Count on ReSound hearing aids's cutting-edge tech for exceptional performance. Get tested today!" />
        <meta property="og:title" content="ReSound Hearing Aid"></meta>
        <meta property="og:description" content="Ready to upgrade your hearing? Count on ReSound hearing aids's cutting-edge tech for exceptional performance. Get tested today!"></meta>
    </Helmet>
      <Header />
      <section className="phonak_hearing">
        <div className="container">
          <h1 className="Heading_text">ReSound</h1>
          <p className="Heading_pergrap">
            GN Resound, one of the world’s largest hearing aid brand was
            established in 1943.
          </p>
        </div>
      </section>

      <section className="HearingSolutions">
        <div className="container">
          <div className="row">
            <div className="img_solution">
              <img src={phonakimg} alt="" className="img-fluid" />

              <h1>GN ReSound: Setting Standards In The Hearing Aid Industry</h1>
              <h5>
                A Pioneering Brand That Has Set Benchmarks With Its Cutting Edge
                Hearing Technology!
              </h5>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <ReactPlayer
                  height="500px"
                  url="https://www.youtube.com/embed/Rdw-BqaKt-s?feature=oembed&enablejsapi=1&origin=https%3A%2F%2Fwww.thehearingcentre.sg"
                  className="video_div"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound Hearing Aids: <br />
                  The History Behind
                </h5>
                <p>
                  GN Resound, one of the world’s largest hearing aid brand was
                  established in 1943. The company holds its expertise in the
                  science of audiology and develops products that are
                  specifically tailored to meet the requirements of its users!
                  Their relentless innovations have allowed the brand to come up
                  with never-before Smart Hearing technology whereby people with
                  hearing loss can communicate and connect with their loved ones
                  again.
                </p>
                <p>
                  The company has brought some of the ground-breaking inventions
                  of the era that includes: the launch of hearing aids for
                  iPhone users that directly lets them stream audio from their
                  iOS device, the release of hearing aid with fine-tuning
                  capabilities via the cloud, the release of precisely
                  engineered hearing aids with a protective nano-scale polymer
                  and much more!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>ReSound Hearing Aid: ReSound OMNIA</h1>
          <h5>The Best Of ReSound Hearing Aids</h5>
          <p>
            ReSound OMNIA is the latest hearing aid model from GN ReSound,
            designed to deliver an exceptional hearing experience. With advanced
            features and state-of-the-art technology, the ReSound OMNIA hearing
            aids are the best choice for those seeking a natural hearing
            experience. The ReSound OMNIA hearing aids utilize a unique
            microphone and receiver-in-ear design to deliver sound that is
            collected naturally. The microphones and receivers are discreetly
            placed in the ear canal, allowing for a comfortable fit and optimal
            sound collection. This innovative technology enables users to easily
            engage with others in any environment, even in noisy and challenging
            situations. Overall, the ReSound OMNIA hearing aids are a
            breakthrough in hearing aid technology, providing a natural and
            effortless hearing experience for all.
          </p>
        </div>
      </section>

      <section className="HistoryBehind Sigin_history">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={saveimg} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound OMNIA Hearing Aid: <br />
                  Mini RIE Rechargeable
                </h5>
                <p>LP, MP, HP, UP and M&RIE receivers</p>
                <p> ReSound color range</p>
                <p> Rechargeable Lithium-Ion battery</p>
                <p>Premium, standard, or desktop charger</p>
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound OMNIA Hearing Aid: <br />
                  RIE 62
                </h5>
                <p>LP, MP, HP, UP and M</p>
                <p>RIE receivers</p>
                <p>ReSound color range</p>
                <p>13 Zinc-Air battery</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={save2img} className="img-fluid" alt="" />
              </div>
            </div>
          </div>

          <div className="menu_new">
            <h6>Key Advantages of ReSound OMNIA Hearing Aid:</h6>
            <ul>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Provides the best natural hearing experience.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Offers greater hearing in any environment.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Filters sound that’s important to you.
              </li>
              <li>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>{" "}
                &nbsp;Gives the best one-on-one hearing experience.
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="KeyFeatures ReSound">
        <div className="container">
          <h1 className="Heading_text">
            ReSound OMNIA Hearing Aids: Key Features
          </h1>
          <div className="silder_div">
            <Slider {...Products}>
              <div>
                <div class="card">
                  <img src={sildeimg1} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Live Assistance </h6>
                    <p class="card-text">
                      Get help from your hearing care professional via ReSound
                      Assist Live video calls without leaving your home
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={sildeimg2} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Rechargeability </h6>
                    <p class="card-text">
                      Stylish powerbank to match your ReSound OMNIA, with up to
                      three days of quick charging on the go
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg3} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Connectivity </h6>
                    <p class="card-text">
                      Unmatched connectivity of ReSound OMNIA via the stable
                      Bluetooth Low Energy connects you directly to iPhones and
                      Android smartphones and tablets, allowing you to stream
                      audio and wireless calls to your hearing aids
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg4} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">M&RIE Design </h6>
                    <p class="card-text">
                      Using your unique ear shape to deliver the most natural
                      sound with more direction and depth
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="card">
                  <img src={sildeimg5} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">All Access Directionality </h6>
                    <p class="card-text">
                      Automatically adjusts to your listening patterns to ensure
                      you are in the best position to hear every sound that’s
                      important to you
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg6} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Ultra Focus </h6>
                    <p class="card-text">
                      Filters background noise and focus on the speech in front
                      of you for a greater one to one listening experience even
                      in the toughest environments
                    </p>
                  </div>
                </div>
              </div>

              <div>
                {" "}
                <div class="card">
                  <img src={sildeimg7} class="card-img-top" alt="..." />
                  <div class="card-body">
                    <h6 class="card-title">Own Voice Processing </h6>
                    <p class="card-text">
                      Separates the wearer’s own voice from other speech and
                      noise for a natural sound, keeping you engaged in
                      conversations
                    </p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>
      <section className="AidLumity">
        <div className="container">
          <h1>ReSound Hearing Aids: A Fine Collection</h1>
          <h5>Giving You A Never-Before Rich Hearing Experience</h5>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound Hearing Aid:
                  <br />
                  ReSound ONE
                </h5>
                <p>
                  To ensure the most optimal hearing experience, GN ReSound has
                  developed their latest model of ReSound hearing aids – the
                  ReSound ONE M&RIE hearing aid. These ReSound ONE hearing aids
                  are the best for giving natural hearing experiences! M&RIE is
                  an abbreviation used for Microphone & Receiver-In-Ear. Its
                  one-of-a-kind architecture and the technology imbibed gives
                  the most natural hearing experience ever offered by any
                  hearing aid.
                </p>
                <p>
                  The duo of an additional microphone and receiver in your ear
                  fits in your ear canal just comfortably and collects the sound
                  which is intended to be collected naturally. This cutting edge
                  technology utilizes the natural shape of your ears to collect
                  and deliver sound. These top of the range ReSound ONE hearing
                  aids allows one to engage effortlessly with others, listening
                  at ease in noisy and challenging situations.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg11} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg15} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound Hearing Aid: <br />
                  ReSound LiNX Quattro
                </h5>
                <p>
                  These series of ReSound hearing aids have top rated sound
                  quality and are able to detect speech precisely from all
                  directions, allowing users to focus on conversations and hear
                  their surroundings simultaneously. With the ReSound LiNX
                  Quattro hearing aids, low and high pitched sounds heard are
                  more natural and crisp with lesser distortions. Its
                  unparalleled range of Bluetooth Low Energy allows for direct
                  streaming of audio to the ReSound hearing aids, providing a
                  world class stereo experience which are compatible with a
                  growing range of iOS and Android smartphones. The ReSound LiNX
                  Quattro hearing aids also offer the best streaming experience
                  in stereo compared to other premium hearing aids. They are
                  highly customizable on the ReSound 3D app to allow for quick
                  adjustments of sound and base setting of these hearing aids.
                  ReSound Assist Live allows user to request assistance from
                  hearing professionals to send new settings directly to users’
                  hearing aids without having to go down to a clinic. In
                  addition, the application provides calming music to mask
                  tinnitus and automatic location-based hearing for ultimate
                  convenience. These ReSound hearing aids are small, discreet
                  and have a long battery life of about 24-30 hours per full
                  charge. The sleek, sturdy and intuitive charging case of the
                  ReSound LINX Quattro hearing aids makes it user-friendly as
                  well. These ReSound hearing aids are highly personalized with
                  a variety of ear fitting and colours to choose from.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="HistoryBehind">
        <div className="container">
          <div className="row align-items-center flex-column-reverse flex-lg-row">
            <div className="col-lg-6 col-md-12">
              <div className="History_text">
                <h5>
                  ReSound Hearing Aid: <br />
                  ReSound Enzo Q
                </h5>
                <p>
                  These ReSound Enzo Q hearing aids are the latest ReSound
                  Behind-The-Ear (BTE) hearing aids that are suitable for
                  individuals with severe to profound hearing loss. These series
                  of ReSound hearing aids provides crystal clear, comfortable
                  and high-quality sounds. ReSound Enzo Q hearing aids are ideal
                  for amplifying speech while automatically adjusting
                  environmental and background noises to suitable levels for
                  users. With these ReSound Enzo Q hearing aids, one can surely
                  hear better in noise as these ReSound hearing aids allows you
                  to follow group conversations and hear where sounds are coming
                  from all around you, while focusing on speech and other sound
                  details. These ReSound hearing aids utilizes Bluetooth 5.0 to
                  connect directly to iOS and Android devices to stream phone
                  calls, music or TV shows with the highest quality of stereo
                  audio conveniently. Similar to the other ReSound hearing aids,
                  the ReSound Enzo Q hearing aids can be personalized on the
                  ReSound Smart 3D app on the phone to further strengthen users’
                  hearing experience. Furthermore, the ReSound Smart 3D app has
                  ReSound Assist Live that allows user to schedule a video call
                  with hearing care professionals to adjust the hearing aids
                  remotely. Resound Enzo Q hearing aids are available in two
                  different styles with a wide range of colours to select from.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="player_history">
                <img src={sildeimg10} className="img-fluid" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="AidLumity">
        <div className="container">
          <h1>ReSound Hearing Aid: Hearing Accessories</h1>
          {/* <h5>The Only Pediatric Hearing Aids In The Market</h5> */}
          <p>
            ReSound hearing aid accessories offer an even smoother hearing
            experience when used in conjuction with ReSound hearing aids.
            Pairing the ReSound accessories with the hearing aids allows for a
            more extensive hearing capability and clearer audio quality while
            making the adjustment of hearing aid settings even more seamless.
            The use of these additional accessories can help to provide users
            with a greater adaptation to noisier environments.
          </p>
        </div>
      </section>

      <section className="Audeo_section ChargingOptions">
        <div className="container">
          <h1 className="Heading_text">
            ReSound Hearing Aid: Hearing Accessories
            <hr />
          </h1>

          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div class="card">
                <img src={mini1} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">ReSound Multi Mic </h5>
                  <p class="card-text">
                    This elegant and flexible ReSound hearing aid microphone
                    allows for hearing up to 25 meters away without the use of
                    additional devices. The ReSound Multi Mic be placed
                    horizontally in front of a speaker to stream sound directly
                    to the ReSound hearing aids.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div class="card">
                <img src={mini2} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">ReSound Phone Clip+ </h5>
                  <p class="card-text">
                    The ReSound Phone Clip+ allows a hand-free experience for
                    users to stream calls and audio from any Bluetooth-enabled
                    mobile phones. This gadget can be clipped onto users’
                    clothes for a more conducive and convenient calling
                    experience.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div class="card">
                <img src={mini3} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">ReSound TV Streamer 2 </h5>
                  <p class="card-text">
                    Connecting your ReSound hearing aids to the innovative
                    ReSound TV Streamer 2 allows for crystal-clear stereo sounds
                    from the TV audio to be streamed directly to the ReSound
                    hearing aids, thus allowing users to enjoy watching TV with
                    friends and family. This ReSound TV Streamer 2 has a large
                    range of 7m and can be used for computer audio as well.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div class="card">
                <img src={mini4} class="card-img-top" alt="..." />
                <div class="card-body">
                  <h5 class="card-title">ReSound Remote Control 2 </h5>
                  <p class="card-text">
                    The ReSound Remote Control 2 allows for maximum control of
                    the ReSound hearing aids at the tip of users’ fingertips.
                    Its sleek design and larger controls allow user to
                    conveniently change the settings and adjust the volumes of
                    their ReSound hearing aids without any hassle. This series
                    of ReSound Remote Control 2 also comes with a high contrast
                    LCD display which clearly shows user their current hearing
                    aid settings at a glance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
